import { useState, useEffect, useCallback } from 'react';
import { AIModel } from '../types';
import { TopModelsService } from '../services/topModelsService';

export const useModelSelection = () => {
  const [allModels, setAllModels] = useState<AIModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTopModels = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🚀 Fetching all top models from Firestore...');
      const models = await TopModelsService.getTopModels();
      
      setAllModels(models);
      console.log(`✅ Loaded ${models.length} models successfully`);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch models';
      setError(errorMessage);
      console.error('❌ Model fetching failed:', errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTopModels();
  }, [fetchTopModels]);

  return {
    allModels,
    loading,
    error,
    refetch: fetchTopModels
  };
};
